__turbopack_context__.v({
  "app_light_theme": "top-panel-module-scss-module__tMMtGG__app_light_theme",
  "openButton": "top-panel-module-scss-module__tMMtGG__openButton",
  "openButton_active": "top-panel-module-scss-module__tMMtGG__openButton_active",
  "title": "top-panel-module-scss-module__tMMtGG__title",
  "title__withMark": "top-panel-module-scss-module__tMMtGG__title__withMark",
  "topPanel": "top-panel-module-scss-module__tMMtGG__topPanel",
});
